import * as moment from 'moment'
import { FocusedInputShape } from 'react-dates'
import {
  Action,
  AsyncState,
  loadingAsyncState,
  none,
  Option,
  some,
  unloadedAsyncState
} from 'widgets-for-react'
import { getWithinRange } from './taxesApi'

export type CollectiveWithTariff = {
  collective_external_id: string
  collective_name: string
  tariff_value: number
}

export type DateRangeState = {
  startDate: Option<moment.Moment>
  endDate: Option<moment.Moment>
  focus: Option<FocusedInputShape>
}

export type Props = {}

export type State = {
  dateRangeState: DateRangeState
  overview: AsyncState<CollectiveWithTariff[]>
}

export type LayoutProps = {
  originalProps: Props
  state: State
  chooseFocus: (focus: FocusedInputShape) => void
  chooseRange: (dates: {
    startDate: moment.Moment
    endDate: moment.Moment
  }) => void
}

export const initialState = (props: Props): State => ({
  dateRangeState: {
    startDate: none(),
    endDate: none(),
    focus: none()
  },
  overview: unloadedAsyncState()
})

export const valueOrNull = <a>(option: Option<a>): a =>
  option.v.kind === 'r' ? option.v.v : null

export const taxesOverviewUpdaters = {
  onOverviewUpdate: (
    updater: Action<AsyncState<CollectiveWithTariff[]>>
  ): Action<State> => s => ({
    ...s,
    overview: updater(s.overview)
  }),

  dateRangeUpdaters: {
    onFocusChange: (focus: FocusedInputShape): Action<State> => s => {
      const newFocus: Option<FocusedInputShape> = !focus ? none() : some(focus)
      return {
        ...s,
        dateRangeState: {
          ...s.dateRangeState,
          focus: newFocus
        }
      }
    },
    onDatesChange: (dates: {
      startDate: moment.Moment
      endDate: moment.Moment
    }): Action<State> => s => {
      const newDateRange = {
        ...s.dateRangeState,
        startDate: !!dates.startDate
          ? some(dates.startDate)
          : s.dateRangeState.startDate,
        endDate: !!dates.endDate
          ? some(dates.endDate)
          : s.dateRangeState.endDate
      }
      const newFocus: Option<FocusedInputShape> =
        newDateRange.startDate.v.kind === 'r'
          ? newDateRange.endDate.v.kind === 'l'
            ? some('endDate')
            : none()
          : newDateRange.endDate.v.kind === 'r'
          ? some('startDate')
          : s.dateRangeState.focus
      return {
        ...s,
        dateRangeState: {
          ...newDateRange,
          focus: newFocus
        },
        overview:
          newDateRange.startDate.v.kind === 'l' ||
          newDateRange.endDate.v.kind === 'l'
            ? s.overview
            : loadingAsyncState(_ =>
                getWithinRange(
                  valueOrNull(newDateRange.startDate),
                  valueOrNull(newDateRange.endDate)
                )
              )
      }
    }
  }
}
